import { render } from "./Container Types.vue?vue&type=template&id=24cb89d4"
import script from "./Container Types.vue?vue&type=script&lang=js"
export * from "./Container Types.vue?vue&type=script&lang=js"

import "./Container Types.vue?vue&type=style&index=0&id=24cb89d4&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__